import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import logo from "./assets/logo.png";
import React, { useState } from 'react';
import Web3 from "web3";
import { ethers } from "ethers";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

var wss = 'wss://patient-quaint-breeze.discover.quiknode.pro/fccd728c3a8c45b0aa81eee005fc7806d56fee6a/';
const web3 = new Web3(wss)


const UNI_ROUTER_ADDRESS = '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D';
const ETH_CONTRACT = '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2';

function App() {

  const [secretKey, setSecretKey] = useState('');
  const [account0, setAccount0] = useState('');
  const [deposited, setDeposited] = useState();
  const [tokenDetect, setTokenDetect] = useState('');
  const [gweiBuy, setgweiBuy] = useState('');
  const [gweiSell, setgweiSell] = useState();
  const [balance, setBalance] = useState('');
  const [deadline, setDeadline] = useState(0);
  const [sellAmount, setSellAmount] = useState(0);
  const [message, setMessage] = useState('');
  const [page, setPage] = useState(1);
  const [sniperContract, setSniperContract] = useState('');
  const [sniperDeposit, setSniperDeposit] = useState('');
  const [slippage,setSlippage] = useState('');
  const [maxBuyTax,setMaxBuyTax] = useState('');
  const [maxSellTax,setMaxSellTax] = useState('');
  const [gasLimit,setGasLimit] = useState('');
  const [autoApprove,setAutoApprove] = useState('');
  const [balanceToken,setBalanceToken] = useState('');
  const [symbolToken,setSymbolToken] = useState('');

  const abi = [{ "inputs": [{ "internalType": "address", "name": "_factory", "type": "address" }, { "internalType": "address", "name": "_WETH", "type": "address" }], "stateMutability": "nonpayable", "type": "constructor" }, { "inputs": [], "name": "WETH", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "tokenA", "type": "address" }, { "internalType": "address", "name": "tokenB", "type": "address" }, { "internalType": "uint256", "name": "amountADesired", "type": "uint256" }, { "internalType": "uint256", "name": "amountBDesired", "type": "uint256" }, { "internalType": "uint256", "name": "amountAMin", "type": "uint256" }, { "internalType": "uint256", "name": "amountBMin", "type": "uint256" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }], "name": "addLiquidity", "outputs": [{ "internalType": "uint256", "name": "amountA", "type": "uint256" }, { "internalType": "uint256", "name": "amountB", "type": "uint256" }, { "internalType": "uint256", "name": "liquidity", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "token", "type": "address" }, { "internalType": "uint256", "name": "amountTokenDesired", "type": "uint256" }, { "internalType": "uint256", "name": "amountTokenMin", "type": "uint256" }, { "internalType": "uint256", "name": "amountETHMin", "type": "uint256" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }], "name": "addLiquidityETH", "outputs": [{ "internalType": "uint256", "name": "amountToken", "type": "uint256" }, { "internalType": "uint256", "name": "amountETH", "type": "uint256" }, { "internalType": "uint256", "name": "liquidity", "type": "uint256" }], "stateMutability": "payable", "type": "function" }, { "inputs": [], "name": "factory", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountOut", "type": "uint256" }, { "internalType": "uint256", "name": "reserveIn", "type": "uint256" }, { "internalType": "uint256", "name": "reserveOut", "type": "uint256" }], "name": "getAmountIn", "outputs": [{ "internalType": "uint256", "name": "amountIn", "type": "uint256" }], "stateMutability": "pure", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountIn", "type": "uint256" }, { "internalType": "uint256", "name": "reserveIn", "type": "uint256" }, { "internalType": "uint256", "name": "reserveOut", "type": "uint256" }], "name": "getAmountOut", "outputs": [{ "internalType": "uint256", "name": "amountOut", "type": "uint256" }], "stateMutability": "pure", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountOut", "type": "uint256" }, { "internalType": "address[]", "name": "path", "type": "address[]" }], "name": "getAmountsIn", "outputs": [{ "internalType": "uint256[]", "name": "amounts", "type": "uint256[]" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountIn", "type": "uint256" }, { "internalType": "address[]", "name": "path", "type": "address[]" }], "name": "getAmountsOut", "outputs": [{ "internalType": "uint256[]", "name": "amounts", "type": "uint256[]" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountA", "type": "uint256" }, { "internalType": "uint256", "name": "reserveA", "type": "uint256" }, { "internalType": "uint256", "name": "reserveB", "type": "uint256" }], "name": "quote", "outputs": [{ "internalType": "uint256", "name": "amountB", "type": "uint256" }], "stateMutability": "pure", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "tokenA", "type": "address" }, { "internalType": "address", "name": "tokenB", "type": "address" }, { "internalType": "uint256", "name": "liquidity", "type": "uint256" }, { "internalType": "uint256", "name": "amountAMin", "type": "uint256" }, { "internalType": "uint256", "name": "amountBMin", "type": "uint256" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }], "name": "removeLiquidity", "outputs": [{ "internalType": "uint256", "name": "amountA", "type": "uint256" }, { "internalType": "uint256", "name": "amountB", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "token", "type": "address" }, { "internalType": "uint256", "name": "liquidity", "type": "uint256" }, { "internalType": "uint256", "name": "amountTokenMin", "type": "uint256" }, { "internalType": "uint256", "name": "amountETHMin", "type": "uint256" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }], "name": "removeLiquidityETH", "outputs": [{ "internalType": "uint256", "name": "amountToken", "type": "uint256" }, { "internalType": "uint256", "name": "amountETH", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "token", "type": "address" }, { "internalType": "uint256", "name": "liquidity", "type": "uint256" }, { "internalType": "uint256", "name": "amountTokenMin", "type": "uint256" }, { "internalType": "uint256", "name": "amountETHMin", "type": "uint256" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }], "name": "removeLiquidityETHSupportingFeeOnTransferTokens", "outputs": [{ "internalType": "uint256", "name": "amountETH", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "token", "type": "address" }, { "internalType": "uint256", "name": "liquidity", "type": "uint256" }, { "internalType": "uint256", "name": "amountTokenMin", "type": "uint256" }, { "internalType": "uint256", "name": "amountETHMin", "type": "uint256" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }, { "internalType": "bool", "name": "approveMax", "type": "bool" }, { "internalType": "uint8", "name": "v", "type": "uint8" }, { "internalType": "bytes32", "name": "r", "type": "bytes32" }, { "internalType": "bytes32", "name": "s", "type": "bytes32" }], "name": "removeLiquidityETHWithPermit", "outputs": [{ "internalType": "uint256", "name": "amountToken", "type": "uint256" }, { "internalType": "uint256", "name": "amountETH", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "token", "type": "address" }, { "internalType": "uint256", "name": "liquidity", "type": "uint256" }, { "internalType": "uint256", "name": "amountTokenMin", "type": "uint256" }, { "internalType": "uint256", "name": "amountETHMin", "type": "uint256" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }, { "internalType": "bool", "name": "approveMax", "type": "bool" }, { "internalType": "uint8", "name": "v", "type": "uint8" }, { "internalType": "bytes32", "name": "r", "type": "bytes32" }, { "internalType": "bytes32", "name": "s", "type": "bytes32" }], "name": "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens", "outputs": [{ "internalType": "uint256", "name": "amountETH", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "tokenA", "type": "address" }, { "internalType": "address", "name": "tokenB", "type": "address" }, { "internalType": "uint256", "name": "liquidity", "type": "uint256" }, { "internalType": "uint256", "name": "amountAMin", "type": "uint256" }, { "internalType": "uint256", "name": "amountBMin", "type": "uint256" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }, { "internalType": "bool", "name": "approveMax", "type": "bool" }, { "internalType": "uint8", "name": "v", "type": "uint8" }, { "internalType": "bytes32", "name": "r", "type": "bytes32" }, { "internalType": "bytes32", "name": "s", "type": "bytes32" }], "name": "removeLiquidityWithPermit", "outputs": [{ "internalType": "uint256", "name": "amountA", "type": "uint256" }, { "internalType": "uint256", "name": "amountB", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountOut", "type": "uint256" }, { "internalType": "address[]", "name": "path", "type": "address[]" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }], "name": "swapETHForExactTokens", "outputs": [{ "internalType": "uint256[]", "name": "amounts", "type": "uint256[]" }], "stateMutability": "payable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountOutMin", "type": "uint256" }, { "internalType": "address[]", "name": "path", "type": "address[]" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }], "name": "swapExactETHForTokens", "outputs": [{ "internalType": "uint256[]", "name": "amounts", "type": "uint256[]" }], "stateMutability": "payable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountOutMin", "type": "uint256" }, { "internalType": "address[]", "name": "path", "type": "address[]" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }], "name": "swapExactETHForTokensSupportingFeeOnTransferTokens", "outputs": [], "stateMutability": "payable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountIn", "type": "uint256" }, { "internalType": "uint256", "name": "amountOutMin", "type": "uint256" }, { "internalType": "address[]", "name": "path", "type": "address[]" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }], "name": "swapExactTokensForETH", "outputs": [{ "internalType": "uint256[]", "name": "amounts", "type": "uint256[]" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountIn", "type": "uint256" }, { "internalType": "uint256", "name": "amountOutMin", "type": "uint256" }, { "internalType": "address[]", "name": "path", "type": "address[]" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }], "name": "swapExactTokensForETHSupportingFeeOnTransferTokens", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountIn", "type": "uint256" }, { "internalType": "uint256", "name": "amountOutMin", "type": "uint256" }, { "internalType": "address[]", "name": "path", "type": "address[]" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }], "name": "swapExactTokensForTokens", "outputs": [{ "internalType": "uint256[]", "name": "amounts", "type": "uint256[]" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountIn", "type": "uint256" }, { "internalType": "uint256", "name": "amountOutMin", "type": "uint256" }, { "internalType": "address[]", "name": "path", "type": "address[]" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }], "name": "swapExactTokensForTokensSupportingFeeOnTransferTokens", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountOut", "type": "uint256" }, { "internalType": "uint256", "name": "amountInMax", "type": "uint256" }, { "internalType": "address[]", "name": "path", "type": "address[]" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }], "name": "swapTokensForExactETH", "outputs": [{ "internalType": "uint256[]", "name": "amounts", "type": "uint256[]" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountOut", "type": "uint256" }, { "internalType": "uint256", "name": "amountInMax", "type": "uint256" }, { "internalType": "address[]", "name": "path", "type": "address[]" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }], "name": "swapTokensForExactTokens", "outputs": [{ "internalType": "uint256[]", "name": "amounts", "type": "uint256[]" }], "stateMutability": "nonpayable", "type": "function" }, { "stateMutability": "payable", "type": "receive" }]
  const swapAbi =  [{"inputs":[{"internalType":"string","name":"_name","type":"string"},{"internalType":"string","name":"_symbol","type":"string"},{"internalType":"uint256","name":"_decimals","type":"uint256"},{"internalType":"uint256","name":"_supply","type":"uint256"},{"internalType":"uint256","name":"_txFee","type":"uint256"},{"internalType":"uint256","name":"_burnFee","type":"uint256"},{"internalType":"uint256","name":"_charityFee","type":"uint256"},{"internalType":"address","name":"_FeeAddress","type":"address"},{"internalType":"address","name":"tokenOwner","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"FeeAddress","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_BURN_FEE","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_CHARITY_FEE","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_TAX_FEE","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_value","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tAmount","type":"uint256"}],"name":"deliver","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"excludeAccount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"includeAccount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isCharity","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isExcluded","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tAmount","type":"uint256"},{"internalType":"bool","name":"deductTransferFee","type":"bool"}],"name":"reflectionFromToken","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"setAsCharityAccount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"rAmount","type":"uint256"}],"name":"tokenFromReflection","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalBurn","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalCharity","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalFees","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_txFee","type":"uint256"},{"internalType":"uint256","name":"_burnFee","type":"uint256"},{"internalType":"uint256","name":"_charityFee","type":"uint256"}],"name":"updateFee","outputs":[],"stateMutability":"nonpayable","type":"function"}]

  function router(account) {
    return new ethers.Contract(
      UNI_ROUTER_ADDRESS,
      [
        'function getAmountsOut(uint amountIn, address[] memory path) public view returns (uint[] memory amounts)',
        'function swapExactTokensForTokens(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline) external returns (uint[] memory amounts)',
        'function swapExactTokensForTokensSupportingFeeOnTransferTokens(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline) external returns (uint[] memory amounts)',
        'function swapExactETHForTokensSupportingFeeOnTransferTokens(uint amountOutMin, address[] calldata path, address to, uint deadline) external payable',
        'function swapExactTokensForETH (uint amountOutMin, address[] calldata path, address to, uint deadline) external payable',
        'function swapExactTokensForETHSupportingFeeOnTransferTokens(uint256 amountIn, uint256 amountOutMin, address[] path, address to, uint256 deadline)'
      ],
      account
    );
  }


  function erc20(account, tokenAddress) {
    return new ethers.Contract(
      tokenAddress,
      [{
        "constant": true,
        "inputs": [{ "name": "_owner", "type": "address" }],
        "name": "balanceOf",
        "outputs": [{ "name": "balance", "type": "uint256" }],
        "payable": false,
        "type": "function"
      },
      { "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" },
      { "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" },
      {
        "constant": false,
        "inputs": [{ "name": "_spender", "type": "address" }, { "name": "_value", "type": "uint256" }],
        "name": "approve",
        "outputs": [{ "name": "", "type": "bool" }],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "owner",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "spender",
            "type": "address"
          }
        ],
        "name": "allowance",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      ],
      account
    );
  }

  const mainAccount = async (e) => {
    e.preventDefault()
    const account0 = web3.eth.accounts.privateKeyToAccount(secretKey);
    setAccount0(account0.address);
    var balance = await web3.eth.getBalance(account0.address);
    setBalance(balance);
  }



  const buyToken = async () => {
    setMessage("BUYING...")
    var customWsProvider = new ethers.providers.WebSocketProvider(wss);
    const wallet = new ethers.Wallet(secretKey);
    const account = wallet.connect(customWsProvider)
    //buyAmount how much are we going to pay for example 0.1 BNB
    let buyAmount = deposited;

   const gweiValue = ethers.utils.parseUnits(gweiBuy, 'gwei');
    // Convert buyAmount to a number and format it to have a maximum of 18 decimal places
    buyAmount = Number.parseFloat(Number(buyAmount).toFixed(18));

    //Slippage refers to the difference between the expected price of a trade and the price at which the trade is executed
    

    //amountOutMin how many token we are going to receive
    let amountOutMin = 0;
    const amountIn = ethers.utils.parseUnits(buyAmount.toString(), 'ether');
    if (parseInt(slippage) !== 0) {
      const amountOutMin = await router(account).getAmountsOut(amountIn, [ETH_CONTRACT, tokenDetect]);
      //amountOutMin = ethers.BigNumber.from(amounts[1].div(100).mul(`${slippage}`)).toHexString();;
      // amountOutMin = amounts[1].sub(amounts[1].div(100).mul(`${slippage}`));
    
    }


   try { const tx = await router(account).swapExactETHForTokensSupportingFeeOnTransferTokens(

      amountOutMin,
      [ETH_CONTRACT, tokenDetect],
      account.address,
      (Date.now() + 1000 * 60 * 10),
      {
        value: amountIn,
        gasPrice: ethers.BigNumber.from(gweiValue).toHexString(),
        gasLimit: ethers.BigNumber.from(gasLimit).toHexString(),

      }
    );




    const receipt = await tx.wait();
    if (receipt && receipt.blockNumber && receipt.status === 1) { // 0 - failed, 1 - success
      console.log(`Transaction https://etherscan.io/tx/${receipt.transactionHash} mined, status success`);
      setMessage(`Transaction https://etherscan.io/tx/${receipt.transactionHash} mined, status success`)

    } else if (receipt && receipt.blockNumber && receipt.status === 0) {
      console.log(`Transaction https://etherscan.io/tx/${receipt.transactionHash} mined, status failed`);
      setMessage(`Transaction https://etherscan.io/tx/${receipt.transactionHash} mined, status failed`)

    } else {
      console.log(`Transaction https://etherscan.io/tx/${receipt.transactionHash} not mined`);
      setMessage(`Transaction https://etherscan.io/tx/${receipt.transactionHash} not mined`)

    }
  } catch {
    setMessage("Buying transaction failed")
  }
} 



  const sellToken = async () => {
  
    setMessage("SELLING...")



    var customWsProvider = new ethers.providers.WebSocketProvider(wss);
    const wallet = new ethers.Wallet(secretKey);
    const account = wallet.connect(customWsProvider)
 
    const contract = new ethers.Contract(UNI_ROUTER_ADDRESS, abi)
    const tokenBalance = await erc20(account, tokenDetect).balanceOf(account.address);
   
    const amountIn = tokenBalance;

 
    if(autoApprove === 1) {
      setMessage("Approving TOKEN")
      const sellTokenContract = new ethers.Contract(tokenDetect,swapAbi,account)
      const approve = await sellTokenContract.approve(UNI_ROUTER_ADDRESS, '1000000000000000000000000000000000000000000000000000000000000')
const receipt_approve = await approve.wait();
if (receipt_approve && receipt_approve.blockNumber && receipt_approve.status === 1) {
console.log(`Approved https://etherscan.io/tx/${receipt_approve.transactionHash}`);
setMessage("Approved https://etherscan.io/tx/", receipt_approve.transactionHash);
     
}
    }

   // const gweiValue = ethers.utils.parseUnits(gweiSell, 'gwei');




   try { const swap_txn = await router(account).swapExactTokensForETHSupportingFeeOnTransferTokens(
      tokenBalance,0,
      [tokenDetect, ETH_CONTRACT],
      account.address,
      (Date.now() + 1000 * 60 * 10),
      {
        gasLimit: ethers.BigNumber.from(gasLimit).toHexString(),
        
      }
    )
    const receipt = await swap_txn.wait();
    if (receipt && receipt.blockNumber && receipt.status === 1) { // 0 - failed, 1 - success
      console.log(`Transaction https://etherscan.io/tx/${receipt.transactionHash} mined, status success`);
      setMessage(`Transaction https://etherscan.io/tx/${receipt.transactionHash} mined, status success`);

    } else if (receipt && receipt.blockNumber && receipt.status === 0) {
      console.log(`Transaction https://etherscan.io/tx/${receipt.transactionHash} mined, status failed`);
      setMessage(`Transaction https://etherscan.io/tx/${receipt.transactionHash} mined, status failed`);

    } else {
      console.log(`Transaction https://etherscan.io/tx/${receipt.transactionHash} not mined`);
      setMessage(`Transaction https://etherscan.io/tx/${receipt.transactionHash} not mined`);

    }} catch {setMessage("Transaction Failed to Sell")}
 
}






  const sellToken2 = async () => {
  
    setMessage("SELLING...")

    var customWsProvider = new ethers.providers.WebSocketProvider(wss);
    const wallet = new ethers.Wallet(secretKey);
    const account = wallet.connect(customWsProvider)
    const contract = new ethers.Contract(UNI_ROUTER_ADDRESS, abi)
    const tokenBalance = await erc20(account, tokenDetect).balanceOf(account.address);
    let amountIn = tokenBalance;
    amountIn = amountIn / 100 * sellAmount;

    if(autoApprove === 1) {
      setMessage("Approving TOKEN")
      const sellTokenContract = new ethers.Contract(tokenDetect,swapAbi,account)
      const approve = await sellTokenContract.approve(UNI_ROUTER_ADDRESS, '1000000000000000000000000000000000000000000000000000000000000')
const receipt_approve = await approve.wait();
if (receipt_approve && receipt_approve.blockNumber && receipt_approve.status === 1) {
console.log(`Approved https://etherscan.io/tx/${receipt_approve.transactionHash}`);
setMessage("Approved https://etherscan.io/tx/", receipt_approve.transactionHash);
     
}
    }
    
   // const gweiValue = ethers.utils.parseUnits(gweiSell, 'gwei');

   try { const swap_txn = await router(account).swapExactTokensForETHSupportingFeeOnTransferTokens(
      amountIn, 0,
      [tokenDetect, ETH_CONTRACT],
      account.address,
      (Date.now() + 1000 * 60 * 200),
      {
      //  gasPrice: ethers.BigNumber.from(gweiValue).toHexString(),
        gasLimit: ethers.BigNumber.from(gasLimit).toHexString(),
      }
    )
    const receipt = await swap_txn.wait();
    if (receipt && receipt.blockNumber && receipt.status === 1) { // 0 - failed, 1 - success
      console.log(`Transaction https://etherscan.io/tx/${receipt.transactionHash} mined, status success`);
      setMessage(`Transaction https://etherscan.io/tx/${receipt.transactionHash} mined, status success`);

    } else if (receipt && receipt.blockNumber && receipt.status === 0) {
      console.log(`Transaction https://etherscan.io/tx/${receipt.transactionHash} mined, status failed`);
      setMessage(`Transaction https://etherscan.io/tx/${receipt.transactionHash} mined, status failed`);

    } else {
      console.log(`Transaction https://etherscan.io/tx/${receipt.transactionHash} not mined`);
      setMessage(`Transaction https://etherscan.io/tx/${receipt.transactionHash} not mined`);

    }
  } catch {
     setMessage("Sell Transaction Failed");
  }

  








  }


  const balanceCheck = async (e) => {
    if(tokenDetect !== '') {
    var customWsProvider = new ethers.providers.WebSocketProvider(wss);
    const wallet = new ethers.Wallet(secretKey);
    const account = wallet.connect(customWsProvider)
    const tokenBalance = await erc20(account, tokenDetect).balanceOf(account.address);
    const tokenSymbol = await erc20(account, tokenDetect).symbol();
    setBalanceToken(tokenBalance / 1e18);
    setSymbolToken(tokenSymbol);
  }
    
  }
  balanceCheck();

  
  // sniperbot 

  const Sniper = async (e) => {
    e.preventDefault();
    setMessage("BOT START: ");
    const addresses = {
      WETH: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
      factory: '0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f',
      router: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
    }
    const provider = new ethers.providers.WebSocketProvider(wss);
    const wallet = new ethers.Wallet(secretKey);

    const account = wallet.connect(provider);
    const factory = new ethers.Contract(
      addresses.factory,
      ['event PairCreated(address indexed token0, address indexed token1, address pair, uint)'],
      account
    );
    const router = new ethers.Contract(
      addresses.router,
      [
        'function getAmountsOut(uint amountIn, address[] memory path) public view returns (uint[] memory amounts)',
        'function swapExactTokensForTokens(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline) external returns (uint[] memory amounts)',
        'function swapExactETHForTokensSupportingFeeOnTransferTokens(uint amountOutMin, address[] calldata path, address to, uint deadline) external payable'
       
      ],
      account
    );

    factory.on('PairCreated', async (token0, token1, pairAddress) => {
      console.log(`
    New pair detected
    =================
    token0: ${token0}
    token1: ${token1}
    pairAddress: ${pairAddress}
  `);

      setMessage("BOT STARTED:", pairAddress);

      //The quote currency needs to be WETH (we will pay with WETH)
      let tokenIn, tokenOut;
      if (token0 === addresses.WETH) {
        if (token1 !== sniperContract) {
          return;
        }
        tokenIn = token0;
        tokenOut = token1;


      }

      if (token1 === addresses.WETH) {
        if (token0 !== sniperContract) {
          return;
        }
        tokenIn = token1;
        tokenOut = token0;

      }

      //The quote currency is not WETH
      if (typeof tokenIn === 'undefined') {
        return;
      }

      //We buy for 0.1 ETH of the new token
      const amountIn = ethers.utils.parseUnits(sniperDeposit, 'ether');
      const amounts = await router.getAmountsOut(amountIn, [tokenIn, tokenOut]);
      //Our execution price will be a bit different, we need some flexbility
      const amountOutMin = amounts[1].sub(amounts[1].div(10));
      console.log(`
    Buying new token
    =================
    tokenIn: ${amountIn.toString()} ${tokenIn} (WETH)
    tokenOut: ${amountOutMin.toString()} ${tokenOut}
  `);
      const tx = await router.swapExactTokensForTokens(
        amountIn,
        amountOutMin,
        [tokenIn, tokenOut],
        account0,
        Date.now() + 1000 * 60 * 10 //10 minutes
      );
      const receipt = await tx.wait();
      console.log('Transaction receipt');
      console.log(receipt);
      setMessage("Successfully Sniped: TX HASH: ",receipt)
    });
  }

  const RemoveAccount = (e) => {
    e.preventDefault();
    setSecretKey('');
  }



  return (
    <>
       <Navbar style={{background:"#20242c"}} variant='dark'>
        <Container>
          <Navbar.Brand href="#home"><img src={logo} alt="logo" width={200}/></Navbar.Brand>
          <Nav className="me-auto">
            {page === 1? <><Nav.Link  onClick={() => setPage(1)} style={{color:"#6acfcc", borderBottom: "2px solid #6acfcc"}} >Sniper</Nav.Link></> : <><Nav.Link  onClick={() => setPage(1)} >Sniper</Nav.Link></>}
            {page === 2? <>   <Nav.Link onClick={() => setPage(2)} style={{color:"#6acfcc", borderBottom: "2px solid #6acfcc"}} >Memepool</Nav.Link></> : <> <Nav.Link onClick={() => setPage(2)}>Memepool</Nav.Link></>}
            {page === 3? <>   <Nav.Link onClick={() => setPage(3)} style={{color:"#6acfcc", borderBottom: "2px solid #6acfcc"}}>Wallets</Nav.Link></> : <>   <Nav.Link onClick={() => setPage(3)}>Wallets</Nav.Link></>}
         
          </Nav>
        </Container>
      </Navbar>
   

      
      <br />
      {message!== ''? <><center><span className='text-center alert alert-primary'>{message}</span></center></>: <></>}
      <br />
      {/* Sniper */}
      <div className='container'>
        {page === 1 ? <>
          <div className='row'>
            <div className='col-sm-3'></div>
            <div className='col-sm-6 text-white'>
           
              <br />


              <div className='row text-white' style={{ background: "#1a212a", borderRadius: "15px 15px 15px 15px", border: "1px solid #32dce2" }} >
                <div className='col-sm-12'>
                  <div className='container'>
                    <br />
                    <h6>Contract Address</h6>
                    <input type='text' className='form-control' placeholder='Put Address Here' value={tokenDetect} onChange={(e) => setTokenDetect(e.target.value)} style={{ background: "#333", color: "#fff",border: "none", height: "50px" }} />
                    <br />
                    <h6>Token Balance</h6>
                    <table className='table text-white'>
                      <tbody>
                      <tr>
                        <td><span style={{color:"#747474"}}>Balance:</span> {balanceToken}</td>
                        <td><span style={{color:"#747474"}}>Symbol:</span> {symbolToken}</td>
                      </tr>
                      </tbody>
                    </table>
                    <div className='row'>
                      <div className='col-sm-4'>
                        <center>
                          <label className='text-center fw-bold'>Sniper Amount</label>
                          <input type='number' placeholder='Type Amount' value={deposited} onChange={(e) => setDeposited(e.target.value)} className='form-control text-center' style={{ background: "#333",color: "#fff", border: "none" }} />
                        </center>
                      </div>
                      <div className='col-sm-4'>
                        <center>
                          <label className='text-center fw-bold'>Sniper Mode</label>
                          <select className='form-control text-center' style={{ background: "#333", color: "#fff", border: "1px solid #6acfcc" }}>
                            <option>ETH</option>
                          </select>
                        </center>
                      </div>
                      <div className='col-sm-4'>
                        <center>
                          <label className='text-center fw-bold'>Max Spend ETH</label>
                          <input type='number' placeholder='Type Max Spend in ETH' className='form-control text-center' style={{ background: "#333",color: "#fff", border: "none" }} />
                        </center>
                      </div>
                    </div>
                    <hr />
                    <br />
                    <div className='row'>
                      <div className='col-sm-6'>
                        <center>  <label className='text-center fw-bold'>{deadline} Second Swap Deadline</label>
                          <input type='range' min="10" max="300" className='slider' value={deadline} onChange={(e) => setDeadline(e.target.value)} style={{ background: "black", width: "100%" }} />
                        </center>
                      </div>
                      <div className='col-sm-6'>
                        <center>
                          <label className='text-center fw-bold'>Custom Sell Percent</label>
                          <input type='range' min="1" max="100" className='slider' value={sellAmount}  onChange={(e) => setSellAmount(e.target.value)} style={{ background: "black", width: "100%" }} />
                        </center>
                      </div>
                    </div>
                    <br />
                  </div>
                </div>
              
              </div>

            </div>
          </div>
          <br />

          <div className='row text-white'>
                <div className='col-sm-3'></div>
                <div className='col-sm-6'>

                  <div className='row' style={{ background: "#1a212a" ,  borderRadius: "15px 15px 15px 15px" ,border: "1px solid #32dce2" }} >

                    <div className='row'>
                      <div className='col-sm-4'>
                        <br />
                        <center>
                          <label className='text-center fw-bold'>Slippage</label>
                          <input type='number' placeholder='1' className='form-control text-center text-white' value={slippage} onChange={(e) => setSlippage(e.target.value)} style={{ background: "#333", border: "none" }} />

                        </center>
                      </div>

                      <div className='col-sm-4'>
                        <br />
                        <center>
                          <label className='text-center fw-bold'>Buy Gwei</label>
                          <input type='number' placeholder='1' className='form-control text-center text-white' value={gweiBuy} onChange={(e) => setgweiBuy(e.target.value)} style={{ background: "#333", border: "none" }} />
                        </center>
                      </div>

                      <div className='col-sm-4'>
                        <br />
                        <center>
                          <label className='text-center fw-bold'>Sell Gwei</label>
                          <input type='number' placeholder='6' className='form-control text-center text-white' value={gweiSell} onChange={(e) => setgweiSell(e.target.value)} style={{ background: "#333", border: "none" }} />
                        </center>
                      </div>
                    </div>

                    <div className='col-sm-12'>
                      <div className='container'>

                        <br />
                        <h5>MAX GAS</h5>
                        <div className='row'>
                          <div className='col-sm-8'>
                            <input type="number" value={gasLimit} onChange={(e) => setGasLimit(e.target.value)} className='form-control text-white' style={{ background: "#333", border: "1px solid black" }} />
                            <br />



                          </div>
                          <div className='col-sm-4'>
                            <div className="form-check form-switch">
                              <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault"  onChange={(e) => {
      const newValue = e.target.checked ? 1 : 0;
      setAutoApprove(newValue);
    }} />
                              <label className="form-check-label" for="flexSwitchCheckDefault">Auto Approval</label>
                            </div>


                          </div>
                        </div>


                        <br />
                        <div className="form-check form-switch">
                          <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" />
                          <label className="form-check-label" for="flexSwitchCheckDefault">Check Honeypot</label>
                        </div>


                        <div className='row'>
                          <div className='col-sm-4'>
                            <br />
                            <center>
                              <label className='text-center fw-bold'>Max Buy Tax</label>
                              <input type='number' placeholder='6%' className='form-control text-center text-white' value={maxBuyTax} onChange={(e) => setMaxBuyTax(e.target.value)} style={{ background: "#333", border: "none" }} />
                            </center>
                          </div>

                          <div className='col-sm-4'>
                            <br />
                            <center>
                              <label className='text-center fw-bold'>Max Sell Tax</label>
                              <input type='number' placeholder='6%' className='form-control text-center text-white' value={maxSellTax} onChange={(e) => setMaxSellTax(e.target.value)} style={{ background: "#333", border: "none" }} />
                            </center>
                          </div>
                        </div>


                        <br />
                      </div>
                    </div>

                  </div>
                 <br />
                 <div className='row'>
                  <div className='col-sm-12' style={{ background: "#1a212a", borderRadius: "15px 15px 15px 15px", width: "100%" , border: "1px solid #32dce2"}}>
                  <br />
           <center>   <table>
                <thead>
                  <tr>
                  <td>  <button className='btn text-white btn-lg text-dark' style={{ background: "#262c33" }} onClick={sellToken2}>SELL {sellAmount}%</button> 
          </td>
                    <td>   <button className='btn text-white btn-lg text-dark' style={{ background: "#2a474e",border: "1px solid #32dce2" }} onClick={sellToken}>SELL 100%</button>
                </td>
              
          <td>   <button className='btn text-white btn-lg text-dark' style={{ background: "#6acfcc" }} onClick={buyToken}>SEND BUY</button> 
            </td>
                  </tr>
                </thead>
              </table>
              </center>
              <br />
                 
                  
                   
                 
          
                </div>
                </div>
                </div>



              </div>

              
        </> : <>
          {page === 2 ? <>
            <div className='row'>
              <div className='col-sm-3'></div>
              <div className='col-sm-6'>
                <div className='row text-white' style={{ background: "#1a212a" ,border: "1px solid #32dce2",borderRadius: "15px 15px 15px 15px"}} >
                  <div className='col-sm-12'>
                    <div className='container'>

                      <br />
                      <h5>Sniper Mode</h5>
                      <h6>{message}</h6>
                      <div className='row'>
                        <div className='col-sm-6'>
                          <select className='form-control' style={{ background: "#333", color: "#fff", border: "1px solid #6acfcc" }}>
                            <option>Memepool</option>
                          </select>
                        </div>
                        <div className='col-sm-6'>
                          <div className="form-check form-switch">
                            <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" />
                            <label className="form-check-label" for="flexSwitchCheckDefault">Snipe Notification</label>
                          </div>
                        </div>
                      </div>
                      <br />
                      <h5>Contract Address</h5>
                      <input type='text' className='form-control' value={sniperContract} onChange={(e) => setSniperContract(e.target.value)} placeholder='Put Address Here' style={{ background: "#333", color: "#fff", border: "none", height:"50px" }} />
                      <br />
                      <div className='row'>
                        <div className='col-sm-4'>
                          <center>
                            <label className='text-center fw-bold'>Mempool Function</label>
                            <select className='form-control text-center' style={{ background: "#333", color: "#fff", border: "1px solid #6acfcc" }}>
                              <option>Buy Trading Enabled</option>
                            </select>
                          </center>
                        </div>

                        <div className='col-sm-4'>
                          <center>
                            <label className='text-center fw-bold'>Deposit</label>
                            <input type='number' placeholder='1' value={sniperDeposit} onChange={(e) => setSniperDeposit(e.target.value)} className='form-control text-center' style={{ background: "#333", color: "#fff", border: "1px solid #6acfcc" }} />
                          </center>
                        </div>

                        <div className='col-sm-4'>

                        </div>
                      </div>
                      <hr />
                      <br />
                      <div className='row'>
                        <div className='col-sm-6'>
                          <center> <button className='btn text-white btn-lg' style={{ background: "#2a474e", border: "1px solid #6acfcc" }}>STOP SCANNING</button>  
                          </center>
                        </div>
                        <div className='col-sm-6'>
                          <center>
                          <button className='btn btn-lg text-white' style={{ background: "#6acfcc" }} onClick={Sniper}>START SCANNING</button>
                          </center>
                        </div>
                      </div>
                      <br />
                    </div>
                  </div>

                </div>

              </div>

            </div>


          </> : <>
            {page === 3 ? <>
              <div className='row'>
                <div className='col-sm-3'></div>
                <div className='col-sm-7'>

                  <div className='row text-white' style={{ background: "#1a212a", border:"1px solid #6bcfcc" }} >
                    <div className='col-sm-8'>
                      <div className='container'>
                        <br />
                        <h5>Private Key</h5>
                        <div className='container'>
                          <div className='row' style={{ background: "#333" }}>
                            <div className='col-sm-10'>
                              <input type='password' className='form-control' placeholder='Enter Private Key' onChange={(e) => setSecretKey(e.target.value)} style={{ background: "none", border: "none" }} />

                            </div>
                            <div className='col-sm-2' >
                              <button className='btn btn-dark text-white' style={{ background: "#6acecc", marginLeft: "10px" }} onClick={mainAccount}>ADD</button>
                            </div>
                          </div>
                        </div>
                        <br />
                        <button className='btn btn-dark text-white' style={{ background: "#2b4a50", border:"1px solid #6bcfcc" }}>Enable All Wallets</button>   <button className='btn btn-dark text-dark' style={{ background: "#6bcfcc" }}>Disable All Wallets</button>
                        <br /> <br />
                        {secretKey !== '' ? <>
                          <p className='alert alert-success'><span className='fw-bold'>{account0}</span></p>
                        </> : <>Account not inserted</>}

                        <hr />
                        <br />

                        <br />
                      </div>
                    </div>
                    <div className='col-sm-4' style={{ background: "#1a212a", borderRadius: "15px 0px 0px 15px" , border:"1px solid #6bcfcc" }}>
                      <br />
                      <p style={{ fontSize: "10px" }}>{<span className='badge bg-success'>{account0}</span>}</p>
                      <p>Balance:</p>
                      <h3>{Number(balance / 1e18).toFixed(4)} ETH</h3>
                      <hr />
                     <button className='btn btn-dark text-dark' style={{ background: "#6bcfcc",  width: "100%" }} onClick={RemoveAccount}>Remove</button> <br /> <br />
                    </div>
                  </div>

                </div>
              </div>


            </> : <>
            </>}
          </>}

        </>}



        <br />
        {/* Account */}

        <br />
        {/* Private Key */}


        <br />
        {/* Config */}

      </div>


    </>
  );
}

export default App;
